var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"f-uniswap-pools",attrs:{"aria-labelledby":_vm.labelId}},[_c('h2',{staticClass:"not-visible",attrs:{"id":_vm.labelId,"data-focus":""}},[_vm._v("Pools")]),_c('FCard',[_c('pairs-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }